import { render } from "./ChangeReturn.vue?vue&type=template&id=40e355c6&scoped=true"
import script from "./ChangeReturn.vue?vue&type=script&lang=js"
export * from "./ChangeReturn.vue?vue&type=script&lang=js"

import "./ChangeReturn.vue?vue&type=style&index=0&id=40e355c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e355c6"]])

export default __exports__